import * as Sentry from '@sentry/react'
import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App.tsx'
import { useAuthStore } from './stores/authStore.ts'

Sentry.init({
  dsn: 'https://2a794c35f0412271d08dcd425da64900@o4510780011577344.ingest.us.sentry.io/4510780570599424',
  sendDefaultPii: true,
  enableLogs: true,
  integrations: [
    // Automatically capture console.error and console.warn as logs
    Sentry.consoleLoggingIntegration({ levels: ['warn', 'error'] }),
    // Browser tracing for performance monitoring
    Sentry.browserTracingIntegration(),
  ],
  // Set sample rate for performance monitoring (1.0 = 100% of transactions)
  tracesSampleRate: 1.0,
})

useAuthStore.subscribe((state, previousState) => {
  const userId = state.user?.id
  if (userId === previousState.user?.id) {
    return
  }

  Sentry.setUser(userId ? { id: userId } : null)
})

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
